import { network } from 'services/network';
import { useQuery } from 'react-query';

export const ProgramProgressOverviewQueryKey = [
    'topOverdue',
    'baselineVsActual',
    'getCriticalityWeightScurveGraph',
    'activitiesWeight',
    'milestoneWeight',
    'highLevelProgram',
    'milestone',
    'getStoredTags',
    'getBaselineVsActual',
];

export const ProgramStatusSummaryReportQueryKeys = [
    'useQueryPrioritiesMatrixCards',
    'useQueryGetMatrixData',
    'keyAchievementsDataTable',
    'summaryTrackedActivitiesTableData',
    'getKeyActivities',
    'getStoredTags',
];

export const ProgramCriticalAnalysisQueryKeys = [
    'activities',
    'topDurations',
    'sharedResourcesAvailability',
    'getStoredTags',
];

export const VersionCompareQueryKeys = [
    'versionCompareTrackedActivitieTableData',
    'finishDateChangesTableData',
    'startDateChangesTableData',
    'statusChangesTableData',
    'largestAddedActivitiesTableData',
    'largestDeletedActivitiesTableData',
    'criticalPathAddedTableData',
    'criticalPathRemovedTableData',
    'largestFloatChangesTableData',
    'largestDurationVarianceTableData',
    'relationshipTypeChangesTableData',
    'relationshipCountChangesTableData',
    'getStoredTags',
];

const getSummaryData = (params) => {
    return network
        .post('api/bo/getVersionSummaryCards', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const useQuerySummaryData = (params) => {
    return useQuery(['summaryDataLine', params], () => getSummaryData(params), {
        enabled: Boolean(params.compareVersionId),
        cacheTime: 0,
    });
};

export { useQuerySummaryData };
